var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// css
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Aif&PmsSidebar.scss";
import "@frameworks/shared-library/assets/icons/edel_icons/style.scss";
import "@frameworks/shared-library/assets/scss/variables/fontFamily.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/components/date-picker.scss";
import "@frameworks/shared-library/assets/scss/global/global.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/select.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/upload.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/radio-component.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/genericScheme.scss";
import "@frameworks/salesjourney/stylesheets/components/Features/LeadGenerate/lead.scss";
import "@frameworks/shared-library/stylesheets/components/Offerings/Generic/OfferingsTable.scss";
// components
import OnboardPopup from "../components/OnboardPopup";
import AddClientDetails from "./client/AddClientDetails";
import PurchaseJourney from "./PurchaseJourney";
import LeadGenerationPartner from "./Features/LeadGeneration/Partner";
import AifPmsDetail from "../components/AifPmsDetail";
import TableComponent from "../components/TableComponent/TableComponent";
import EdModal from "@frameworks/shared-library/components/edModal";
// helpers
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { pmsTabs } from "../constants";
import { purchaseController } from "../controller";
import { ESubProductIds, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
// types
import { TransactionTypeCodeEnum, } from "@domains/features/Markets/AIF-PMS/entities/GlobalEntity";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import { ILoginTypeEnum } from "@domains/salesFeatures/Login/entities/iLogin";
import { CLICKED_FROM_DRAFT } from "@redux/feature/Markets/InvestmentManagement/interface";
import { FieldNames } from "../constants/constant";
import actions from "@mainDi/features/AIF-PMS/actions";
function InvestmentJourney(_a) {
    //
    var _this = this;
    var _b, _c;
    var subCategoryId = _a.subCategoryId;
    var dispatch = useDispatch();
    var _d = __read(useState(1), 2), fundTotalPages = _d[0], setFundTotalPages = _d[1];
    var _e = __read(useState(false), 2), rowOpenSB = _e[0], setRowOpenSb = _e[1];
    var _f = __read(useState(false), 2), addClientVisible = _f[0], setAddClientVisible = _f[1];
    var _g = __read(useState(false), 2), partnerLeadVisible = _g[0], setPartnerLeadVisible = _g[1];
    var _h = __read(useState({
        category_code: subCategoryId,
        page: 1,
        pageSize: 10,
        orderByDesc: true,
        orderBy: "returns_expectations",
    }), 2), requestPayload = _h[0], setRequestPayload = _h[1];
    var _j = __read(useState(false), 2), onboardPopup = _j[0], setOnboardPopup = _j[1];
    var _k = __read(useState([]), 2), watchlistData = _k[0], setWatchlistData = _k[1];
    var _l = __read(useState(false), 2), purchaseVisible = _l[0], setPurchaseVisible = _l[1];
    var _m = __read(useState({}), 2), userData = _m[0], setUserData = _m[1];
    var _o = purchaseController(), onClickContinue = _o.onClickContinue, loading = _o.loading, clearPurchaseValues = _o.clearPurchaseValues, errorMessage = _o.errorMessage, errorVisible = _o.errorVisible, setLoading = _o.setLoading;
    var partnerCategory = localStorage.getItem(ELocalStorageKeys.LoginType);
    var searchParams = new URLSearchParams(location.search);
    var cActions = actions();
    var _p = useSelector(function (state) { return state.markets.AifPms; }), watchlist = _p.watchlist, totalPages = _p.totalPages, selectedWatchListData = _p.watchListData, errorData = _p.errorData, message = _p.message, productDetails = _p.productDetails, clickedFromDraft = _p.clickedFromDraft, clientDetails = _p.clientDetails, draftOrderDetails = _p.draftOrderDetails;
    var activeTypeList = useSelector(function (state) { return state.markets.global; }).activeTypeList;
    useEffect(function () {
        aifPmsDi.aifPms.updateSubCategoryId(subCategoryId);
    }, [subCategoryId]);
    useEffect(function () {
        if (partnerCategory !== ILoginTypeEnum.PARTNER) {
            aifPmsDi.global
                .userPopupStatus({
                category_code: subCategoryId,
                show_popup: false,
            })
                .then(function (data) {
                setUserData(data.data);
            })
                .catch(function () {
                //
            });
        }
    }, []);
    useEffect(function () {
        aifPmsDi.global.trxTypeList({
            categoryCode: subCategoryId,
        });
    }, []);
    useEffect(function () {
        aifPmsDi.draft.getDraftOrderCount({
            categoryCode: Number(subCategoryId),
        });
    }, []);
    useEffect(function () {
        aifPmsDi.aifPms
            .getAifPmsWatchList(requestPayload)
            .then(function (response) {
            //
        })
            .catch(function (error) {
            //
        });
    }, [requestPayload]);
    var fetchFilterDetails = function (subCategoryId, fieldName) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, aifPmsDi.aifPms.getFilterDetails({
                    category_code: String(subCategoryId),
                    fieldName: fieldName,
                })];
        });
    }); };
    useEffect(function () {
        fetchFundName();
        if (Number(subCategoryId) === Number(ESubProductIds.AIF)) {
            getFilters(subCategoryId);
        }
        else {
            fetchFilterDetails(subCategoryId, FieldNames.AMCNAME).then(function (res) {
                if (res) {
                    fetchFilterDetails(subCategoryId, FieldNames.FUNDMANAGER);
                }
            });
        }
    }, []);
    var getFilters = function (subCategoryId) { return __awaiter(_this, void 0, void 0, function () {
        var filterNames, filterNames_1, filterNames_1_1, fieldName, e_1_1;
        var e_1, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    filterNames = [
                        FieldNames.CATEGORY,
                        FieldNames.AMCNAME,
                        FieldNames.FUNDMANAGER,
                    ];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    filterNames_1 = __values(filterNames), filterNames_1_1 = filterNames_1.next();
                    _b.label = 2;
                case 2:
                    if (!!filterNames_1_1.done) return [3 /*break*/, 5];
                    fieldName = filterNames_1_1.value;
                    return [4 /*yield*/, fetchFilterDetails(subCategoryId, fieldName)];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    filterNames_1_1 = filterNames_1.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_1_1 = _b.sent();
                    e_1 = { error: e_1_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (filterNames_1_1 && !filterNames_1_1.done && (_a = filterNames_1.return)) _a.call(filterNames_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var fetchFundName = function () {
        aifPmsDi.aifPms
            .getFilterDetails({
            category_code: String(subCategoryId),
            fieldName: FieldNames.FUND_NAME,
            orderByDesc: true,
            page: 1,
            pageSize: 10,
        })
            .then(function (res) {
            setFundTotalPages(res === null || res === void 0 ? void 0 : res.totalpages);
        });
    };
    var handleSearch = function (value) { return __awaiter(_this, void 0, void 0, function () {
        var localFilterData, res, localFilterData, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!value) return [3 /*break*/, 2];
                    localFilterData = __assign(__assign({}, requestPayload), { searchText: value, page: 1 });
                    return [4 /*yield*/, aifPmsDi.aifPms.getAifPmsWatchList(localFilterData)];
                case 1:
                    res = _a.sent();
                    setWatchlistData(res === null || res === void 0 ? void 0 : res.data);
                    return [3 /*break*/, 5];
                case 2:
                    localFilterData = __assign(__assign({}, requestPayload), { page: 1 });
                    delete localFilterData.searchText;
                    return [4 /*yield*/, aifPmsDi.aifPms.getAifPmsWatchList(localFilterData)];
                case 3:
                    _a.sent();
                    return [4 /*yield*/, aifPmsDi.aifPms.getAifPmsWatchList(localFilterData)];
                case 4:
                    res = _a.sent();
                    setWatchlistData(res === null || res === void 0 ? void 0 : res.data);
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var profileData = useSelector(function (state) {
        return state.Profile.ProfileDetails.reducersData.data.profileDetails;
    });
    useEffect(function () {
        if (requestPayload.page > 1) {
            setWatchlistData(function (prev) {
                var uniqueItems = new Set(prev.map(function (item) { return item.schemeId; }));
                var newItems = watchlist.filter(function (item) { return !uniqueItems.has(item.schemeId); });
                return __spreadArray(__spreadArray([], __read(prev), false), __read(newItems), false);
            });
        }
        else {
            setWatchlistData(watchlist);
        }
    }, [requestPayload, watchlist]);
    useEffect(function () {
        var _a;
        var categoryCode = searchParams.get("categoryCode");
        var ucc = searchParams.get("ucc") || ((_a = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _a === void 0 ? void 0 : _a.ucccode);
        var schemeid = searchParams.get("schemeid");
        var fetchProductDetails = function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!schemeid) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, aifPmsDi.aifPms.getProductDetails({
                                schemeId: Number(schemeid),
                                category_code: Number(categoryCode),
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error("Error fetching product details:", error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var fetchClientDetails = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, client, error_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!clickedFromDraft && ucc)) return [3 /*break*/, 6];
                        if (!![
                            TransactionTypeCodeEnum.Redeem,
                            TransactionTypeCodeEnum.TransferIn,
                        ].includes(activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code)) return [3 /*break*/, 5];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, aifPmsDi.global.uccCodeClientSearch({
                                uccCode: ucc,
                            })];
                    case 2:
                        response = _b.sent();
                        client = response === null || response === void 0 ? void 0 : response.data;
                        if (client) {
                            aifPmsDi.aifPms.updateClientDetails({
                                clientName: client.acname,
                                userName: client.acname,
                                accountCode: client.ac_code,
                                pan: client.pan,
                                mobileNo: client.mobileNo,
                                email: client.email,
                                uniqueCode: client.ucccode,
                                ucccode: client.ucccode,
                                clienttier: client.clienttier,
                            });
                            dispatch({
                                type: CLICKED_FROM_DRAFT,
                                payload: { clickedFromDraft: false },
                            });
                            // aifPmsDi.leadservice.leadsSearch({
                            //   searchBy: "CRITERIA_ALL_LEAD",
                            //   assignedTo: profileData?.empcodetxt
                            //     ? profileData?.empcodetxt
                            //     : "",
                            //   mobile: client?.mobileNo
                            //     ? client?.mobileNo
                            //     : clientDetails?.mobileNo,
                            //   emailId: client?.email ? client?.email : clientDetails?.email,
                            //   productId: 56,
                            //   categoryId: subCategoryId,
                            //   subCategoryId: 0,
                            //   leadSource: "AIFPMS",
                            //   displayNameId: searchParams.get("schemeid")
                            //     ? Number(searchParams.get("schemeid"))
                            //     : selectedWatchListData.schemeId,
                            //   pan: client?.pan ? client?.pan : clientDetails?.pan,
                            //   EntityTypeId: checkFourthChar(
                            //     client?.pan ? client?.pan : clientDetails?.pan
                            //   ),
                            // });
                            if (searchParams.get("orderId")) {
                                aifPmsDi.draft.draftOrderDetails({
                                    trx_id: Number((_a = searchParams.get("orderId")) !== null && _a !== void 0 ? _a : ""),
                                });
                            }
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _b.sent();
                        console.error("Error fetching client details:", error_2);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        clearPurchaseValues();
                        _b.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        }); };
        fetchProductDetails();
        fetchClientDetails();
    }, [clickedFromDraft, activeTypeList === null || activeTypeList === void 0 ? void 0 : activeTypeList.trx_type_code, subCategoryId]);
    useEffect(function () {
        var _a;
        if (searchParams.get("orderId")) {
            aifPmsDi.aifPms.updateTransactionId(Number(searchParams.get("orderId")));
            aifPmsDi.draft.draftOrderDetails({
                trx_id: Number((_a = searchParams.get("orderId")) !== null && _a !== void 0 ? _a : ""),
            });
        }
    }, [searchParams.get("orderId")]);
    useEffect(function () {
        var _a, _b, _c, _d;
        var params = new Map([
            ["categoryCode", searchParams.get("categoryCode")],
            ["ucc", searchParams.get("ucc")],
            ["schemeid", searchParams.get("schemeid")],
            ["orderId", searchParams.get("orderId")],
        ]);
        if (((productDetails === null || productDetails === void 0 ? void 0 : productDetails.schemeId) && params.get("schemeid")) ||
            params.get("orderId")) {
            aifPmsDi.aifPms.updateWatchListData({
                display_name: (productDetails === null || productDetails === void 0 ? void 0 : productDetails.schemeName) || ((_a = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _a === void 0 ? void 0 : _a.scheme_name),
                isfocused: productDetails.isFocused,
                inception_date: productDetails.inceptionDate,
                tenure: productDetails.expectedTenure,
                returns_expectations: productDetails.returnExpected,
                benchmark: productDetails.benchMark,
                schemeId: productDetails.schemeId || ((_b = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _b === void 0 ? void 0 : _b.scheme_id),
                min_investment: Number(productDetails.min_Investment_Amount),
                min_investment_in_cr: productDetails.min_Investment_Amount_In_Cr,
                isin_code: productDetails.isin_code ||
                    productDetails.isinCode ||
                    ((_c = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _c === void 0 ? void 0 : _c.isin_code),
                amc_product_name: productDetails.amc_product_name ||
                    productDetails.amcProductName ||
                    ((_d = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _d === void 0 ? void 0 : _d.issuer_name),
                category: productDetails.category || (draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data.category),
            });
            setPurchaseVisible(true);
            return function () { return setPurchaseVisible(false); };
        }
    }, [productDetails, draftOrderDetails]);
    var handleOpen = function () {
        if (!userData) {
            setOnboardPopup(true);
        }
        else {
            setOnboardPopup(false);
            setPurchaseVisible(true);
        }
    };
    var onClickContinueOnboardModal = function (checked) {
        if (checked) {
            aifPmsDi.global
                .userPopupStatusSave({
                category_code: subCategoryId,
                show_popup: checked,
            })
                .then(function (data) {
                setOnboardPopup(false);
                setPurchaseVisible(true);
            })
                .catch(function (error) {
                //
            });
        }
        else {
            setOnboardPopup(false);
            setPurchaseVisible(true);
        }
    };
    var onClickPlaceOrder = useCallback(function (item) {
        if (partnerCategory == ILoginTypeEnum.PARTNER) {
            setPartnerLeadVisible(true);
        }
        else {
            if (searchParams.get("leadid") !== "" &&
                searchParams.get("leadid") !== null &&
                searchParams.get("leadid") !== undefined &&
                Object.values(productDetails).every(function (e) { return e == null; })) {
                cActions.global.selectLeadId("");
                clearPurchaseValues();
                handleOpen();
            }
            else {
                clearPurchaseValues();
                handleOpen();
            }
        }
        aifPmsDi.aifPms.updateWatchListData(item);
    }, [
        partnerCategory,
        setPartnerLeadVisible,
        clearPurchaseValues,
        handleOpen,
        ILoginTypeEnum,
        productDetails,
    ]);
    var onRowClick = useCallback(function (item) {
        setRowOpenSb(true);
        aifPmsDi.aifPms.updateWatchListData(item);
    }, [setRowOpenSb]);
    var onClickDraftPlaceOrder = useCallback(function (item) {
        aifPmsDi.aifPms.updateWatchListData(item);
        setPurchaseVisible(true);
    }, [setPurchaseVisible]);
    var onClickCancel = useCallback(function () {
        setPurchaseVisible(false);
        clearPurchaseValues();
        aifPmsDi.aifPms.ordersData(null);
    }, [setPurchaseVisible, clearPurchaseValues]);
    var onSelectClient = useCallback(function (item) {
        if (item.ispansearch == "true") {
            setPurchaseVisible(false);
            setAddClientVisible(true);
        }
    }, [setPurchaseVisible, setAddClientVisible]);
    var onClickClose = useCallback(function () {
        setRowOpenSb(false);
        clearPurchaseValues();
    }, [setRowOpenSb, clearPurchaseValues]);
    var placeOrderByDetails = useCallback(function () {
        if (partnerCategory == ILoginTypeEnum.PARTNER) {
            setPartnerLeadVisible(true);
        }
        else {
            clearPurchaseValues();
            setRowOpenSb(false);
            handleOpen();
            aifPmsDi.aifPms.updateWatchListData({
                display_name: selectedWatchListData === null || selectedWatchListData === void 0 ? void 0 : selectedWatchListData.display_name,
                isfocused: selectedWatchListData.isfocused,
                inception_date: selectedWatchListData.inception_date,
                tenure: selectedWatchListData.tenure,
                returns_expectations: selectedWatchListData.returns_expectations,
                benchmark: selectedWatchListData.benchmark,
                schemeId: selectedWatchListData === null || selectedWatchListData === void 0 ? void 0 : selectedWatchListData.schemeId,
                min_investment: selectedWatchListData.min_investment,
                min_investment_in_cr: selectedWatchListData.min_investment_in_cr,
            });
        }
    }, [
        partnerCategory,
        clearPurchaseValues,
        setRowOpenSb,
        handleOpen,
        selectedWatchListData,
    ]);
    function checkFourthChar(input) {
        var _a;
        if ((input === null || input === void 0 ? void 0 : input.length) >= 4 && ((_a = input === null || input === void 0 ? void 0 : input[3]) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === "P") {
            return 55;
        }
        return 56;
    }
    var onClickVerify = useCallback(function (response, schemeId) {
        if (response.data.length > 0) {
            setAddClientVisible(false);
            setPurchaseVisible(true);
            setLoading(false);
            // aifPmsDi.leadservice
            //   .leadsSearch({
            //     searchBy: "CRITERIA_ALL_LEAD",
            //     assignedTo: profileData?.empcodetxt ? profileData?.empcodetxt : "",
            //     mobile: response?.data?.[0]?.mobileno
            //       ? response?.data?.[0]?.mobileno
            //       : "",
            //     emailId: response?.data?.[0]?.email
            //       ? response?.data?.[0]?.email
            //       : "",
            //     productId: Number(EProductIds.MANAGED_PORTFOLIO),
            //     categoryId: subCategoryId,
            //     subCategoryId: 0,
            //     leadSource: "AIFPMS",
            //     displayNameId: schemeId,
            //     pan: response?.data?.[0]?.pan,
            //     EntityTypeId: checkFourthChar(response?.data?.[0]?.pan),
            //   })
            //   .then(() => {
            //     setLoading(false);
            //   });
        }
    }, [setAddClientVisible, setPurchaseVisible, loading, setLoading]);
    var onClickClientCancel = function () {
        setAddClientVisible(false);
        setPurchaseVisible(true);
        aifPmsDi.aifPms.updateClientDetails(null);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TableComponent, { tabList: pmsTabs, aifPmsListData: watchlistData, setRowOpenSb: setRowOpenSb, setRequestPayload: setRequestPayload, requestPayload: requestPayload, totalPages: totalPages, message: message, subCategoryId: subCategoryId, error: errorData, rowOnClick: onRowClick, onClickPlaceOrder: onClickPlaceOrder, onClickDraftPlaceOrder: onClickDraftPlaceOrder, handleCallbackSearchFunds: handleSearch, fundTotalPages: fundTotalPages, setFundTotalPages: setFundTotalPages }),
        purchaseVisible && (React.createElement(PurchaseJourney, { subCategoryId: subCategoryId, loading: loading, visible: purchaseVisible, setVisible: setPurchaseVisible, onClickContinue: onClickContinue, onClickCancel: onClickCancel, onSelectClient: onSelectClient, errorMessage: errorMessage, errorVisible: errorVisible })),
        partnerLeadVisible && (React.createElement(LeadGenerationPartner, { visible: partnerLeadVisible, setVisible: setPartnerLeadVisible })),
        React.createElement(AifPmsDetail, { visible: rowOpenSB, subCategoryId: subCategoryId, setVisible: setRowOpenSb, item: {
                schemeId: (_b = selectedWatchListData === null || selectedWatchListData === void 0 ? void 0 : selectedWatchListData.schemeId) !== null && _b !== void 0 ? _b : 0,
                fundName: (_c = selectedWatchListData === null || selectedWatchListData === void 0 ? void 0 : selectedWatchListData.display_name) !== null && _c !== void 0 ? _c : "",
            }, onClickClose: onClickClose, onClickPlaceOrder: placeOrderByDetails, isPartner: partnerCategory == ILoginTypeEnum.PARTNER }),
        React.createElement(AddClientDetails, { visible: addClientVisible, setVisible: setAddClientVisible, onClickVerify: onClickVerify, onClickCancel: onClickClientCancel }),
        onboardPopup && (React.createElement(EdModal, { show: onboardPopup, size: "modal-dialog-centered modal-xl first-order", setShow: setOnboardPopup, showFooter: false, modalTitle: "", customModalHeader: React.createElement(React.Fragment, null) },
            React.createElement(OnboardPopup, { setOnboardPopup: setOnboardPopup, onClickContinue: onClickContinueOnboardModal })))));
}
export default InvestmentJourney;
